const template = document.createElement('template');
template.innerHTML = `
<style>
  .personalisation-font-selector {
    display: flex;
    gap: 0.625rem;
    margin-bottom: 4rem
  }

  .font-option {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.0625rem solid rgba(18, 50, 71, 0.12);
    border-radius: 0.5rem;
    height: 3.5rem;
    cursor: pointer;
    background-color: transparent;
    width: calc(100% / 3);

    font-size: 1rem;
    font-weight: 485;
    line-height: 1.5rem;
    letter-spacing: 0.02rem;
    text-transform: uppercase;
  }

  .font-option.is-active {
    border-color: var(--opaque-lark-navy);
  }

  .font-option-label {
    display: none;
  }

  .font-modern {
    font-family: var(--font-secondary);
    font-weight: 400;
  }

  .font-chinese {
    font-family: var(--font-tertiary);
    font-weight: 400;
  }

  @media screen and (max-width: 1099px) {
    .font-option {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 68.75rem) {
    .personalisation-font-selector {
      margin-bottom: 1.75rem;
    }
  }
</style>

<div class="personalisation-font-selector">
  <label class="font-option is-active" for="traditional">TRADITIONAL</label>
  <input class="font-option-label" type="radio" id="traditional" name="fontStyle" value="Traditional" checked>
  <label class="font-option font-modern" for="modern">MODERN</label>
  <input class="font-option-label" type="radio" id="modern" name="fontStyle" value="Modern">
  <label class="font-option font-chinese" for="chinese">中国人</label>
  <input class="font-option-label" type="radio" id="chinese" name="fontStyle" value="Chinese">
</div>
`;

export class PersonalisationFontSelector extends HTMLElement {

  private readonly root:HTMLDivElement|null;
  private componentValue: string = this.getAttribute('data-font-value') || "";

  constructor() {
    super();

    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.root = shadowRoot.querySelector('.personalisation-font-selector');
  }

  connectedCallback() {
    this.root.addEventListener('change', this.handleFontChange.bind(this));
    this.setDefaultFont();

    if(this.componentValue) {
      this.setFont(this.componentValue);
      const targetInput = this.root.querySelector<HTMLInputElement>(`input[value="${this.componentValue}"]`);
      if(targetInput) {
        this.updateActiveLabel(targetInput.id);
      }
    }
  }

  public handleFontChange(e: Event) {
    if (e.target instanceof HTMLInputElement && e.target.name === 'fontStyle') {
      this.setFont(e.target.value);
      this.updateActiveLabel(e.target.id);
    }
  }

  public setFont(fontType: string) {
    let fontValue = 'var(--font-primary)';
    if (fontType === 'Modern') fontValue = 'var(--font-secondary)';
    if (fontType === 'Chinese') fontValue = 'var(--font-tertiary)';

    this.dispatchEvent(new CustomEvent('font_selected', {
      bubbles: true,
      composed: true,
      detail: {
        fontType,
        fontValue
      }
    }));
  }

  public updateActiveLabel(targetId: string) {
    const labels = this.root?.querySelectorAll('.font-option');
    labels?.forEach(label => {
      if (label.htmlFor === targetId) {
        label.classList.add('is-active');
      } else {
        label.classList.remove('is-active');
      }
    });
  }

  public setDefaultFont() {
    this.dispatchEvent(new CustomEvent('font_selected', {
      bubbles: true,
      composed: true,
      detail: {
        fontType: 'Traditional',
        fontValue: 'var(--font-primary)'
      }
    }));
  }
}

if(!customElements.get('personalisation-font-selector')) {
  customElements.define('personalisation-font-selector', PersonalisationFontSelector);
}